import { EditCommand } from "./EditCommand";

export abstract class AbstractRemoveValueOfArrayCommand<TSource, TValue> extends EditCommand<TSource, { index: number, value: TValue }> {
  constructor(index: number) {
    super(
      s => {
        const array = this.readArray(s);
        const backuppedIndex = ((index !== null) && (index !== undefined)) ? index : array.length;
        return {
          index: backuppedIndex,
          value: array[backuppedIndex],
        };
      },
      s => {
        const array = this.readArray(s);
        array.splice(((index !== null) && (index !== undefined)) ? index : array.length, 1);
      },
      (s, b) => this.readArray(s).splice(b.index, 0, b.value)
    );
  }

  protected abstract readArray(source: TSource): TValue[];
}
